/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  // return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
  return /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

export function isPassWord (s)
{
  return /^(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[a-z])[(0-9A-Za-z)]{6,}$/.test(s)
}


export function isIdCardNo (pId) {
  pId = pId.toLowerCase()
  let arrVerifyCode = [1, 0, 'x', 9, 8, 7, 6, 5, 4, 3, 2]
  let wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  if (pId.length !== 15 && pId.length !== 18) {
    return false
  }
  let ai = pId.length === 18 ? pId.substring(0, 17) : pId.slice(0, 6) + '19' + pId.slice(6, 16)
  if (!/^\d+$/.test(ai)) {
    return false
  }
  let yyyy = ai.slice(6, 10)
  let mm = ai.slice(10, 12) - 1
  let dd = ai.slice(12, 14)
  let d = new Date(yyyy, mm, dd)
  let now = new Date()
  let year = d.getFullYear()
  let mon = d.getMonth()
  let day = d.getDate()
  if (year !== parseInt(yyyy) || mon !== parseInt(mm) || day !== parseInt(dd) || d > now || year < 1900) {
    return false
  }
  for (var i = 0, ret = 0; i < 17; i++) {
    ret += ai.charAt(i) * wi[i]
  }
  ai += arrVerifyCode[ret %= 11]
  return pId.length === 18 && pId === ai
}

export function areaReg (area) {
  return /^\d*(?:\.\d{0,2})?$/.test(area);
}

export function isPositiveInt (s) {
  return /^[1-9]\d*$/.test(s);
}

export function isInt (s) {
  return /^[0-9]\d*$/.test(s);
}